/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthIndexRouteImport } from './routes/auth.index'
import { Route as DemoWorkflowRouteImport } from './routes/demo.workflow'
import { Route as AuthSsoCallbackRouteImport } from './routes/auth.sso-callback'
import { Route as AuthSignUpRouteImport } from './routes/auth.sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth.sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthFactorTwoRouteImport } from './routes/auth.factor-two'
import { Route as AuthFactorOneRouteImport } from './routes/auth.factor-one'
import { Route as ProtectedSubstituteRouteImport } from './routes/_protected.substitute'
import { Route as ProtectedProviderRouteImport } from './routes/_protected.provider'
import { Route as ProtectedProfileRouteImport } from './routes/_protected.profile'
import { Route as ProtectedOperatorsRouteImport } from './routes/_protected.operators'
import { Route as ProtectedInvoicesRouteImport } from './routes/_protected.invoices'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected.dashboard'
import { Route as ProviderPaymentSuccessRouteImport } from './routes/provider/payment/success'
import { Route as ProviderPaymentCancelledRouteImport } from './routes/provider/payment/cancelled'
import { Route as ProviderBillingDutyIdRouteImport } from './routes/provider.billing.$dutyId'
import { Route as ProtectedSubstituteServicesRouteImport } from './routes/_protected.substitute.services'
import { Route as ProtectedSubstituteMessagesRouteImport } from './routes/_protected.substitute.messages'
import { Route as ProtectedSubstituteMarketplaceRouteImport } from './routes/_protected.substitute.marketplace'
import { Route as ProtectedSubstituteDashboardRouteImport } from './routes/_protected.substitute.dashboard'
import { Route as ProtectedSubstituteApplicationsRouteImport } from './routes/_protected.substitute.applications'
import { Route as ProtectedSubstituteIdRouteImport } from './routes/_protected.substitute.$id'
import { Route as ProtectedProviderServicesRouteImport } from './routes/_protected.provider.services'
import { Route as ProtectedProviderMessagesRouteImport } from './routes/_protected.provider.messages'
import { Route as ProtectedProviderDashboardRouteImport } from './routes/_protected.provider.dashboard'
import { Route as ProtectedOperatorsVerificationRouteImport } from './routes/_protected.operators.verification'
import { Route as ProtectedOperatorsUsersRouteImport } from './routes/_protected.operators.users'
import { Route as ProtectedOperatorsSettingsRouteImport } from './routes/_protected.operators.settings'
import { Route as ProtectedOperatorsServicesRouteImport } from './routes/_protected.operators.services'
import { Route as ProtectedOperatorsServiceAreasRouteImport } from './routes/_protected.operators.service-areas'
import { Route as ProtectedOperatorsReportingRouteImport } from './routes/_protected.operators.reporting'
import { Route as ProtectedOperatorsEmailsTestRouteImport } from './routes/_protected.operators.emails-test'
import { Route as ProtectedOperatorsDashboardRouteImport } from './routes/_protected.operators.dashboard'
import { Route as ProtectedOperatorsCouponsRouteImport } from './routes/_protected.operators.coupons'
import { Route as ProtectedOperatorsContactsRouteImport } from './routes/_protected.operators.contacts'
import { Route as ProtectedOperatorsBlogRouteImport } from './routes/_protected.operators.blog'
import { Route as ProtectedOperatorsAccountingRouteImport } from './routes/_protected.operators.accounting'
import { Route as ProtectedOperatorsVerificationIndexRouteImport } from './routes/_protected.operators.verification.index'
import { Route as ProtectedOperatorsUsersIndexRouteImport } from './routes/_protected.operators.users.index'
import { Route as ProtectedOperatorsServicesIndexRouteImport } from './routes/_protected.operators.services.index'
import { Route as ProtectedOperatorsBlogIndexRouteImport } from './routes/_protected.operators.blog.index'
import { Route as ProtectedProviderServiceIdRouteImport } from './routes/_protected.provider.service.$id'
import { Route as ProtectedOperatorsVerificationUserIdRouteImport } from './routes/_protected.operators.verification.$userId'
import { Route as ProtectedOperatorsUsersUserIdRouteImport } from './routes/_protected.operators.users.$userId'
import { Route as ProtectedOperatorsServicesServiceIdRouteImport } from './routes/_protected.operators.services.$serviceId'
import { Route as ProtectedOperatorsBlogPostIdRouteImport } from './routes/_protected.operators.blog.$postId'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const DemoWorkflowRoute = DemoWorkflowRouteImport.update({
  id: '/demo/workflow',
  path: '/demo/workflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFactorTwoRoute = AuthFactorTwoRouteImport.update({
  id: '/factor-two',
  path: '/factor-two',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFactorOneRoute = AuthFactorOneRouteImport.update({
  id: '/factor-one',
  path: '/factor-one',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedSubstituteRoute = ProtectedSubstituteRouteImport.update({
  id: '/substitute',
  path: '/substitute',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProviderRoute = ProtectedProviderRouteImport.update({
  id: '/provider',
  path: '/provider',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedOperatorsRoute = ProtectedOperatorsRouteImport.update({
  id: '/operators',
  path: '/operators',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedInvoicesRoute = ProtectedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProviderPaymentSuccessRoute = ProviderPaymentSuccessRouteImport.update({
  id: '/provider/payment/success',
  path: '/provider/payment/success',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderPaymentCancelledRoute =
  ProviderPaymentCancelledRouteImport.update({
    id: '/provider/payment/cancelled',
    path: '/provider/payment/cancelled',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderBillingDutyIdRoute = ProviderBillingDutyIdRouteImport.update({
  id: '/provider/billing/$dutyId',
  path: '/provider/billing/$dutyId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedSubstituteServicesRoute =
  ProtectedSubstituteServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => ProtectedSubstituteRoute,
  } as any)
const ProtectedSubstituteMessagesRoute =
  ProtectedSubstituteMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedSubstituteRoute,
  } as any)
const ProtectedSubstituteMarketplaceRoute =
  ProtectedSubstituteMarketplaceRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => ProtectedSubstituteRoute,
  } as any)
const ProtectedSubstituteDashboardRoute =
  ProtectedSubstituteDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ProtectedSubstituteRoute,
  } as any)
const ProtectedSubstituteApplicationsRoute =
  ProtectedSubstituteApplicationsRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => ProtectedSubstituteRoute,
  } as any)
const ProtectedSubstituteIdRoute = ProtectedSubstituteIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProtectedSubstituteRoute,
} as any)
const ProtectedProviderServicesRoute =
  ProtectedProviderServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => ProtectedProviderRoute,
  } as any)
const ProtectedProviderMessagesRoute =
  ProtectedProviderMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => ProtectedProviderRoute,
  } as any)
const ProtectedProviderDashboardRoute =
  ProtectedProviderDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ProtectedProviderRoute,
  } as any)
const ProtectedOperatorsVerificationRoute =
  ProtectedOperatorsVerificationRouteImport.update({
    id: '/verification',
    path: '/verification',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsUsersRoute = ProtectedOperatorsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ProtectedOperatorsRoute,
} as any)
const ProtectedOperatorsSettingsRoute =
  ProtectedOperatorsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsServicesRoute =
  ProtectedOperatorsServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsServiceAreasRoute =
  ProtectedOperatorsServiceAreasRouteImport.update({
    id: '/service-areas',
    path: '/service-areas',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsReportingRoute =
  ProtectedOperatorsReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsEmailsTestRoute =
  ProtectedOperatorsEmailsTestRouteImport.update({
    id: '/emails-test',
    path: '/emails-test',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsDashboardRoute =
  ProtectedOperatorsDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsCouponsRoute =
  ProtectedOperatorsCouponsRouteImport.update({
    id: '/coupons',
    path: '/coupons',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsContactsRoute =
  ProtectedOperatorsContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsBlogRoute = ProtectedOperatorsBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => ProtectedOperatorsRoute,
} as any)
const ProtectedOperatorsAccountingRoute =
  ProtectedOperatorsAccountingRouteImport.update({
    id: '/accounting',
    path: '/accounting',
    getParentRoute: () => ProtectedOperatorsRoute,
  } as any)
const ProtectedOperatorsVerificationIndexRoute =
  ProtectedOperatorsVerificationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOperatorsVerificationRoute,
  } as any)
const ProtectedOperatorsUsersIndexRoute =
  ProtectedOperatorsUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOperatorsUsersRoute,
  } as any)
const ProtectedOperatorsServicesIndexRoute =
  ProtectedOperatorsServicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOperatorsServicesRoute,
  } as any)
const ProtectedOperatorsBlogIndexRoute =
  ProtectedOperatorsBlogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOperatorsBlogRoute,
  } as any)
const ProtectedProviderServiceIdRoute =
  ProtectedProviderServiceIdRouteImport.update({
    id: '/service/$id',
    path: '/service/$id',
    getParentRoute: () => ProtectedProviderRoute,
  } as any)
const ProtectedOperatorsVerificationUserIdRoute =
  ProtectedOperatorsVerificationUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => ProtectedOperatorsVerificationRoute,
  } as any)
const ProtectedOperatorsUsersUserIdRoute =
  ProtectedOperatorsUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => ProtectedOperatorsUsersRoute,
  } as any)
const ProtectedOperatorsServicesServiceIdRoute =
  ProtectedOperatorsServicesServiceIdRouteImport.update({
    id: '/$serviceId',
    path: '/$serviceId',
    getParentRoute: () => ProtectedOperatorsServicesRoute,
  } as any)
const ProtectedOperatorsBlogPostIdRoute =
  ProtectedOperatorsBlogPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => ProtectedOperatorsBlogRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/auth': typeof AuthRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/invoices': typeof ProtectedInvoicesRoute
  '/operators': typeof ProtectedOperatorsRouteWithChildren
  '/profile': typeof ProtectedProfileRoute
  '/provider': typeof ProtectedProviderRouteWithChildren
  '/substitute': typeof ProtectedSubstituteRouteWithChildren
  '/auth/factor-one': typeof AuthFactorOneRoute
  '/auth/factor-two': typeof AuthFactorTwoRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/demo/workflow': typeof DemoWorkflowRoute
  '/auth/': typeof AuthIndexRoute
  '/operators/accounting': typeof ProtectedOperatorsAccountingRoute
  '/operators/blog': typeof ProtectedOperatorsBlogRouteWithChildren
  '/operators/contacts': typeof ProtectedOperatorsContactsRoute
  '/operators/coupons': typeof ProtectedOperatorsCouponsRoute
  '/operators/dashboard': typeof ProtectedOperatorsDashboardRoute
  '/operators/emails-test': typeof ProtectedOperatorsEmailsTestRoute
  '/operators/reporting': typeof ProtectedOperatorsReportingRoute
  '/operators/service-areas': typeof ProtectedOperatorsServiceAreasRoute
  '/operators/services': typeof ProtectedOperatorsServicesRouteWithChildren
  '/operators/settings': typeof ProtectedOperatorsSettingsRoute
  '/operators/users': typeof ProtectedOperatorsUsersRouteWithChildren
  '/operators/verification': typeof ProtectedOperatorsVerificationRouteWithChildren
  '/provider/dashboard': typeof ProtectedProviderDashboardRoute
  '/provider/messages': typeof ProtectedProviderMessagesRoute
  '/provider/services': typeof ProtectedProviderServicesRoute
  '/substitute/$id': typeof ProtectedSubstituteIdRoute
  '/substitute/applications': typeof ProtectedSubstituteApplicationsRoute
  '/substitute/dashboard': typeof ProtectedSubstituteDashboardRoute
  '/substitute/marketplace': typeof ProtectedSubstituteMarketplaceRoute
  '/substitute/messages': typeof ProtectedSubstituteMessagesRoute
  '/substitute/services': typeof ProtectedSubstituteServicesRoute
  '/provider/billing/$dutyId': typeof ProviderBillingDutyIdRoute
  '/provider/payment/cancelled': typeof ProviderPaymentCancelledRoute
  '/provider/payment/success': typeof ProviderPaymentSuccessRoute
  '/operators/blog/$postId': typeof ProtectedOperatorsBlogPostIdRoute
  '/operators/services/$serviceId': typeof ProtectedOperatorsServicesServiceIdRoute
  '/operators/users/$userId': typeof ProtectedOperatorsUsersUserIdRoute
  '/operators/verification/$userId': typeof ProtectedOperatorsVerificationUserIdRoute
  '/provider/service/$id': typeof ProtectedProviderServiceIdRoute
  '/operators/blog/': typeof ProtectedOperatorsBlogIndexRoute
  '/operators/services/': typeof ProtectedOperatorsServicesIndexRoute
  '/operators/users/': typeof ProtectedOperatorsUsersIndexRoute
  '/operators/verification/': typeof ProtectedOperatorsVerificationIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/invoices': typeof ProtectedInvoicesRoute
  '/operators': typeof ProtectedOperatorsRouteWithChildren
  '/profile': typeof ProtectedProfileRoute
  '/provider': typeof ProtectedProviderRouteWithChildren
  '/substitute': typeof ProtectedSubstituteRouteWithChildren
  '/auth/factor-one': typeof AuthFactorOneRoute
  '/auth/factor-two': typeof AuthFactorTwoRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/demo/workflow': typeof DemoWorkflowRoute
  '/auth': typeof AuthIndexRoute
  '/operators/accounting': typeof ProtectedOperatorsAccountingRoute
  '/operators/contacts': typeof ProtectedOperatorsContactsRoute
  '/operators/coupons': typeof ProtectedOperatorsCouponsRoute
  '/operators/dashboard': typeof ProtectedOperatorsDashboardRoute
  '/operators/emails-test': typeof ProtectedOperatorsEmailsTestRoute
  '/operators/reporting': typeof ProtectedOperatorsReportingRoute
  '/operators/service-areas': typeof ProtectedOperatorsServiceAreasRoute
  '/operators/settings': typeof ProtectedOperatorsSettingsRoute
  '/provider/dashboard': typeof ProtectedProviderDashboardRoute
  '/provider/messages': typeof ProtectedProviderMessagesRoute
  '/provider/services': typeof ProtectedProviderServicesRoute
  '/substitute/$id': typeof ProtectedSubstituteIdRoute
  '/substitute/applications': typeof ProtectedSubstituteApplicationsRoute
  '/substitute/dashboard': typeof ProtectedSubstituteDashboardRoute
  '/substitute/marketplace': typeof ProtectedSubstituteMarketplaceRoute
  '/substitute/messages': typeof ProtectedSubstituteMessagesRoute
  '/substitute/services': typeof ProtectedSubstituteServicesRoute
  '/provider/billing/$dutyId': typeof ProviderBillingDutyIdRoute
  '/provider/payment/cancelled': typeof ProviderPaymentCancelledRoute
  '/provider/payment/success': typeof ProviderPaymentSuccessRoute
  '/operators/blog/$postId': typeof ProtectedOperatorsBlogPostIdRoute
  '/operators/services/$serviceId': typeof ProtectedOperatorsServicesServiceIdRoute
  '/operators/users/$userId': typeof ProtectedOperatorsUsersUserIdRoute
  '/operators/verification/$userId': typeof ProtectedOperatorsVerificationUserIdRoute
  '/provider/service/$id': typeof ProtectedProviderServiceIdRoute
  '/operators/blog': typeof ProtectedOperatorsBlogIndexRoute
  '/operators/services': typeof ProtectedOperatorsServicesIndexRoute
  '/operators/users': typeof ProtectedOperatorsUsersIndexRoute
  '/operators/verification': typeof ProtectedOperatorsVerificationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/admin': typeof AdminRoute
  '/auth': typeof AuthRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/invoices': typeof ProtectedInvoicesRoute
  '/_protected/operators': typeof ProtectedOperatorsRouteWithChildren
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/provider': typeof ProtectedProviderRouteWithChildren
  '/_protected/substitute': typeof ProtectedSubstituteRouteWithChildren
  '/auth/factor-one': typeof AuthFactorOneRoute
  '/auth/factor-two': typeof AuthFactorTwoRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/sso-callback': typeof AuthSsoCallbackRoute
  '/demo/workflow': typeof DemoWorkflowRoute
  '/auth/': typeof AuthIndexRoute
  '/_protected/operators/accounting': typeof ProtectedOperatorsAccountingRoute
  '/_protected/operators/blog': typeof ProtectedOperatorsBlogRouteWithChildren
  '/_protected/operators/contacts': typeof ProtectedOperatorsContactsRoute
  '/_protected/operators/coupons': typeof ProtectedOperatorsCouponsRoute
  '/_protected/operators/dashboard': typeof ProtectedOperatorsDashboardRoute
  '/_protected/operators/emails-test': typeof ProtectedOperatorsEmailsTestRoute
  '/_protected/operators/reporting': typeof ProtectedOperatorsReportingRoute
  '/_protected/operators/service-areas': typeof ProtectedOperatorsServiceAreasRoute
  '/_protected/operators/services': typeof ProtectedOperatorsServicesRouteWithChildren
  '/_protected/operators/settings': typeof ProtectedOperatorsSettingsRoute
  '/_protected/operators/users': typeof ProtectedOperatorsUsersRouteWithChildren
  '/_protected/operators/verification': typeof ProtectedOperatorsVerificationRouteWithChildren
  '/_protected/provider/dashboard': typeof ProtectedProviderDashboardRoute
  '/_protected/provider/messages': typeof ProtectedProviderMessagesRoute
  '/_protected/provider/services': typeof ProtectedProviderServicesRoute
  '/_protected/substitute/$id': typeof ProtectedSubstituteIdRoute
  '/_protected/substitute/applications': typeof ProtectedSubstituteApplicationsRoute
  '/_protected/substitute/dashboard': typeof ProtectedSubstituteDashboardRoute
  '/_protected/substitute/marketplace': typeof ProtectedSubstituteMarketplaceRoute
  '/_protected/substitute/messages': typeof ProtectedSubstituteMessagesRoute
  '/_protected/substitute/services': typeof ProtectedSubstituteServicesRoute
  '/provider/billing/$dutyId': typeof ProviderBillingDutyIdRoute
  '/provider/payment/cancelled': typeof ProviderPaymentCancelledRoute
  '/provider/payment/success': typeof ProviderPaymentSuccessRoute
  '/_protected/operators/blog/$postId': typeof ProtectedOperatorsBlogPostIdRoute
  '/_protected/operators/services/$serviceId': typeof ProtectedOperatorsServicesServiceIdRoute
  '/_protected/operators/users/$userId': typeof ProtectedOperatorsUsersUserIdRoute
  '/_protected/operators/verification/$userId': typeof ProtectedOperatorsVerificationUserIdRoute
  '/_protected/provider/service/$id': typeof ProtectedProviderServiceIdRoute
  '/_protected/operators/blog/': typeof ProtectedOperatorsBlogIndexRoute
  '/_protected/operators/services/': typeof ProtectedOperatorsServicesIndexRoute
  '/_protected/operators/users/': typeof ProtectedOperatorsUsersIndexRoute
  '/_protected/operators/verification/': typeof ProtectedOperatorsVerificationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/dashboard'
    | '/invoices'
    | '/operators'
    | '/profile'
    | '/provider'
    | '/substitute'
    | '/auth/factor-one'
    | '/auth/factor-two'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/sso-callback'
    | '/demo/workflow'
    | '/auth/'
    | '/operators/accounting'
    | '/operators/blog'
    | '/operators/contacts'
    | '/operators/coupons'
    | '/operators/dashboard'
    | '/operators/emails-test'
    | '/operators/reporting'
    | '/operators/service-areas'
    | '/operators/services'
    | '/operators/settings'
    | '/operators/users'
    | '/operators/verification'
    | '/provider/dashboard'
    | '/provider/messages'
    | '/provider/services'
    | '/substitute/$id'
    | '/substitute/applications'
    | '/substitute/dashboard'
    | '/substitute/marketplace'
    | '/substitute/messages'
    | '/substitute/services'
    | '/provider/billing/$dutyId'
    | '/provider/payment/cancelled'
    | '/provider/payment/success'
    | '/operators/blog/$postId'
    | '/operators/services/$serviceId'
    | '/operators/users/$userId'
    | '/operators/verification/$userId'
    | '/provider/service/$id'
    | '/operators/blog/'
    | '/operators/services/'
    | '/operators/users/'
    | '/operators/verification/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/invoices'
    | '/operators'
    | '/profile'
    | '/provider'
    | '/substitute'
    | '/auth/factor-one'
    | '/auth/factor-two'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/sso-callback'
    | '/demo/workflow'
    | '/auth'
    | '/operators/accounting'
    | '/operators/contacts'
    | '/operators/coupons'
    | '/operators/dashboard'
    | '/operators/emails-test'
    | '/operators/reporting'
    | '/operators/service-areas'
    | '/operators/settings'
    | '/provider/dashboard'
    | '/provider/messages'
    | '/provider/services'
    | '/substitute/$id'
    | '/substitute/applications'
    | '/substitute/dashboard'
    | '/substitute/marketplace'
    | '/substitute/messages'
    | '/substitute/services'
    | '/provider/billing/$dutyId'
    | '/provider/payment/cancelled'
    | '/provider/payment/success'
    | '/operators/blog/$postId'
    | '/operators/services/$serviceId'
    | '/operators/users/$userId'
    | '/operators/verification/$userId'
    | '/provider/service/$id'
    | '/operators/blog'
    | '/operators/services'
    | '/operators/users'
    | '/operators/verification'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/admin'
    | '/auth'
    | '/_protected/dashboard'
    | '/_protected/invoices'
    | '/_protected/operators'
    | '/_protected/profile'
    | '/_protected/provider'
    | '/_protected/substitute'
    | '/auth/factor-one'
    | '/auth/factor-two'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/sso-callback'
    | '/demo/workflow'
    | '/auth/'
    | '/_protected/operators/accounting'
    | '/_protected/operators/blog'
    | '/_protected/operators/contacts'
    | '/_protected/operators/coupons'
    | '/_protected/operators/dashboard'
    | '/_protected/operators/emails-test'
    | '/_protected/operators/reporting'
    | '/_protected/operators/service-areas'
    | '/_protected/operators/services'
    | '/_protected/operators/settings'
    | '/_protected/operators/users'
    | '/_protected/operators/verification'
    | '/_protected/provider/dashboard'
    | '/_protected/provider/messages'
    | '/_protected/provider/services'
    | '/_protected/substitute/$id'
    | '/_protected/substitute/applications'
    | '/_protected/substitute/dashboard'
    | '/_protected/substitute/marketplace'
    | '/_protected/substitute/messages'
    | '/_protected/substitute/services'
    | '/provider/billing/$dutyId'
    | '/provider/payment/cancelled'
    | '/provider/payment/success'
    | '/_protected/operators/blog/$postId'
    | '/_protected/operators/services/$serviceId'
    | '/_protected/operators/users/$userId'
    | '/_protected/operators/verification/$userId'
    | '/_protected/provider/service/$id'
    | '/_protected/operators/blog/'
    | '/_protected/operators/services/'
    | '/_protected/operators/users/'
    | '/_protected/operators/verification/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AdminRoute: typeof AdminRoute
  AuthRoute: typeof AuthRouteWithChildren
  DemoWorkflowRoute: typeof DemoWorkflowRoute
  ProviderBillingDutyIdRoute: typeof ProviderBillingDutyIdRoute
  ProviderPaymentCancelledRoute: typeof ProviderPaymentCancelledRoute
  ProviderPaymentSuccessRoute: typeof ProviderPaymentSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/demo/workflow': {
      id: '/demo/workflow'
      path: '/demo/workflow'
      fullPath: '/demo/workflow'
      preLoaderRoute: typeof DemoWorkflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sso-callback': {
      id: '/auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/auth/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/factor-two': {
      id: '/auth/factor-two'
      path: '/factor-two'
      fullPath: '/auth/factor-two'
      preLoaderRoute: typeof AuthFactorTwoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/factor-one': {
      id: '/auth/factor-one'
      path: '/factor-one'
      fullPath: '/auth/factor-one'
      preLoaderRoute: typeof AuthFactorOneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/substitute': {
      id: '/_protected/substitute'
      path: '/substitute'
      fullPath: '/substitute'
      preLoaderRoute: typeof ProtectedSubstituteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/provider': {
      id: '/_protected/provider'
      path: '/provider'
      fullPath: '/provider'
      preLoaderRoute: typeof ProtectedProviderRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/operators': {
      id: '/_protected/operators'
      path: '/operators'
      fullPath: '/operators'
      preLoaderRoute: typeof ProtectedOperatorsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/invoices': {
      id: '/_protected/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof ProtectedInvoicesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/provider/payment/success': {
      id: '/provider/payment/success'
      path: '/provider/payment/success'
      fullPath: '/provider/payment/success'
      preLoaderRoute: typeof ProviderPaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/payment/cancelled': {
      id: '/provider/payment/cancelled'
      path: '/provider/payment/cancelled'
      fullPath: '/provider/payment/cancelled'
      preLoaderRoute: typeof ProviderPaymentCancelledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/billing/$dutyId': {
      id: '/provider/billing/$dutyId'
      path: '/provider/billing/$dutyId'
      fullPath: '/provider/billing/$dutyId'
      preLoaderRoute: typeof ProviderBillingDutyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/substitute/services': {
      id: '/_protected/substitute/services'
      path: '/services'
      fullPath: '/substitute/services'
      preLoaderRoute: typeof ProtectedSubstituteServicesRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/substitute/messages': {
      id: '/_protected/substitute/messages'
      path: '/messages'
      fullPath: '/substitute/messages'
      preLoaderRoute: typeof ProtectedSubstituteMessagesRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/substitute/marketplace': {
      id: '/_protected/substitute/marketplace'
      path: '/marketplace'
      fullPath: '/substitute/marketplace'
      preLoaderRoute: typeof ProtectedSubstituteMarketplaceRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/substitute/dashboard': {
      id: '/_protected/substitute/dashboard'
      path: '/dashboard'
      fullPath: '/substitute/dashboard'
      preLoaderRoute: typeof ProtectedSubstituteDashboardRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/substitute/applications': {
      id: '/_protected/substitute/applications'
      path: '/applications'
      fullPath: '/substitute/applications'
      preLoaderRoute: typeof ProtectedSubstituteApplicationsRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/substitute/$id': {
      id: '/_protected/substitute/$id'
      path: '/$id'
      fullPath: '/substitute/$id'
      preLoaderRoute: typeof ProtectedSubstituteIdRouteImport
      parentRoute: typeof ProtectedSubstituteRoute
    }
    '/_protected/provider/services': {
      id: '/_protected/provider/services'
      path: '/services'
      fullPath: '/provider/services'
      preLoaderRoute: typeof ProtectedProviderServicesRouteImport
      parentRoute: typeof ProtectedProviderRoute
    }
    '/_protected/provider/messages': {
      id: '/_protected/provider/messages'
      path: '/messages'
      fullPath: '/provider/messages'
      preLoaderRoute: typeof ProtectedProviderMessagesRouteImport
      parentRoute: typeof ProtectedProviderRoute
    }
    '/_protected/provider/dashboard': {
      id: '/_protected/provider/dashboard'
      path: '/dashboard'
      fullPath: '/provider/dashboard'
      preLoaderRoute: typeof ProtectedProviderDashboardRouteImport
      parentRoute: typeof ProtectedProviderRoute
    }
    '/_protected/operators/verification': {
      id: '/_protected/operators/verification'
      path: '/verification'
      fullPath: '/operators/verification'
      preLoaderRoute: typeof ProtectedOperatorsVerificationRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/users': {
      id: '/_protected/operators/users'
      path: '/users'
      fullPath: '/operators/users'
      preLoaderRoute: typeof ProtectedOperatorsUsersRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/settings': {
      id: '/_protected/operators/settings'
      path: '/settings'
      fullPath: '/operators/settings'
      preLoaderRoute: typeof ProtectedOperatorsSettingsRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/services': {
      id: '/_protected/operators/services'
      path: '/services'
      fullPath: '/operators/services'
      preLoaderRoute: typeof ProtectedOperatorsServicesRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/service-areas': {
      id: '/_protected/operators/service-areas'
      path: '/service-areas'
      fullPath: '/operators/service-areas'
      preLoaderRoute: typeof ProtectedOperatorsServiceAreasRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/reporting': {
      id: '/_protected/operators/reporting'
      path: '/reporting'
      fullPath: '/operators/reporting'
      preLoaderRoute: typeof ProtectedOperatorsReportingRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/emails-test': {
      id: '/_protected/operators/emails-test'
      path: '/emails-test'
      fullPath: '/operators/emails-test'
      preLoaderRoute: typeof ProtectedOperatorsEmailsTestRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/dashboard': {
      id: '/_protected/operators/dashboard'
      path: '/dashboard'
      fullPath: '/operators/dashboard'
      preLoaderRoute: typeof ProtectedOperatorsDashboardRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/coupons': {
      id: '/_protected/operators/coupons'
      path: '/coupons'
      fullPath: '/operators/coupons'
      preLoaderRoute: typeof ProtectedOperatorsCouponsRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/contacts': {
      id: '/_protected/operators/contacts'
      path: '/contacts'
      fullPath: '/operators/contacts'
      preLoaderRoute: typeof ProtectedOperatorsContactsRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/blog': {
      id: '/_protected/operators/blog'
      path: '/blog'
      fullPath: '/operators/blog'
      preLoaderRoute: typeof ProtectedOperatorsBlogRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/accounting': {
      id: '/_protected/operators/accounting'
      path: '/accounting'
      fullPath: '/operators/accounting'
      preLoaderRoute: typeof ProtectedOperatorsAccountingRouteImport
      parentRoute: typeof ProtectedOperatorsRoute
    }
    '/_protected/operators/verification/': {
      id: '/_protected/operators/verification/'
      path: '/'
      fullPath: '/operators/verification/'
      preLoaderRoute: typeof ProtectedOperatorsVerificationIndexRouteImport
      parentRoute: typeof ProtectedOperatorsVerificationRoute
    }
    '/_protected/operators/users/': {
      id: '/_protected/operators/users/'
      path: '/'
      fullPath: '/operators/users/'
      preLoaderRoute: typeof ProtectedOperatorsUsersIndexRouteImport
      parentRoute: typeof ProtectedOperatorsUsersRoute
    }
    '/_protected/operators/services/': {
      id: '/_protected/operators/services/'
      path: '/'
      fullPath: '/operators/services/'
      preLoaderRoute: typeof ProtectedOperatorsServicesIndexRouteImport
      parentRoute: typeof ProtectedOperatorsServicesRoute
    }
    '/_protected/operators/blog/': {
      id: '/_protected/operators/blog/'
      path: '/'
      fullPath: '/operators/blog/'
      preLoaderRoute: typeof ProtectedOperatorsBlogIndexRouteImport
      parentRoute: typeof ProtectedOperatorsBlogRoute
    }
    '/_protected/provider/service/$id': {
      id: '/_protected/provider/service/$id'
      path: '/service/$id'
      fullPath: '/provider/service/$id'
      preLoaderRoute: typeof ProtectedProviderServiceIdRouteImport
      parentRoute: typeof ProtectedProviderRoute
    }
    '/_protected/operators/verification/$userId': {
      id: '/_protected/operators/verification/$userId'
      path: '/$userId'
      fullPath: '/operators/verification/$userId'
      preLoaderRoute: typeof ProtectedOperatorsVerificationUserIdRouteImport
      parentRoute: typeof ProtectedOperatorsVerificationRoute
    }
    '/_protected/operators/users/$userId': {
      id: '/_protected/operators/users/$userId'
      path: '/$userId'
      fullPath: '/operators/users/$userId'
      preLoaderRoute: typeof ProtectedOperatorsUsersUserIdRouteImport
      parentRoute: typeof ProtectedOperatorsUsersRoute
    }
    '/_protected/operators/services/$serviceId': {
      id: '/_protected/operators/services/$serviceId'
      path: '/$serviceId'
      fullPath: '/operators/services/$serviceId'
      preLoaderRoute: typeof ProtectedOperatorsServicesServiceIdRouteImport
      parentRoute: typeof ProtectedOperatorsServicesRoute
    }
    '/_protected/operators/blog/$postId': {
      id: '/_protected/operators/blog/$postId'
      path: '/$postId'
      fullPath: '/operators/blog/$postId'
      preLoaderRoute: typeof ProtectedOperatorsBlogPostIdRouteImport
      parentRoute: typeof ProtectedOperatorsBlogRoute
    }
  }
}

interface ProtectedOperatorsBlogRouteChildren {
  ProtectedOperatorsBlogPostIdRoute: typeof ProtectedOperatorsBlogPostIdRoute
  ProtectedOperatorsBlogIndexRoute: typeof ProtectedOperatorsBlogIndexRoute
}

const ProtectedOperatorsBlogRouteChildren: ProtectedOperatorsBlogRouteChildren =
  {
    ProtectedOperatorsBlogPostIdRoute: ProtectedOperatorsBlogPostIdRoute,
    ProtectedOperatorsBlogIndexRoute: ProtectedOperatorsBlogIndexRoute,
  }

const ProtectedOperatorsBlogRouteWithChildren =
  ProtectedOperatorsBlogRoute._addFileChildren(
    ProtectedOperatorsBlogRouteChildren,
  )

interface ProtectedOperatorsServicesRouteChildren {
  ProtectedOperatorsServicesServiceIdRoute: typeof ProtectedOperatorsServicesServiceIdRoute
  ProtectedOperatorsServicesIndexRoute: typeof ProtectedOperatorsServicesIndexRoute
}

const ProtectedOperatorsServicesRouteChildren: ProtectedOperatorsServicesRouteChildren =
  {
    ProtectedOperatorsServicesServiceIdRoute:
      ProtectedOperatorsServicesServiceIdRoute,
    ProtectedOperatorsServicesIndexRoute: ProtectedOperatorsServicesIndexRoute,
  }

const ProtectedOperatorsServicesRouteWithChildren =
  ProtectedOperatorsServicesRoute._addFileChildren(
    ProtectedOperatorsServicesRouteChildren,
  )

interface ProtectedOperatorsUsersRouteChildren {
  ProtectedOperatorsUsersUserIdRoute: typeof ProtectedOperatorsUsersUserIdRoute
  ProtectedOperatorsUsersIndexRoute: typeof ProtectedOperatorsUsersIndexRoute
}

const ProtectedOperatorsUsersRouteChildren: ProtectedOperatorsUsersRouteChildren =
  {
    ProtectedOperatorsUsersUserIdRoute: ProtectedOperatorsUsersUserIdRoute,
    ProtectedOperatorsUsersIndexRoute: ProtectedOperatorsUsersIndexRoute,
  }

const ProtectedOperatorsUsersRouteWithChildren =
  ProtectedOperatorsUsersRoute._addFileChildren(
    ProtectedOperatorsUsersRouteChildren,
  )

interface ProtectedOperatorsVerificationRouteChildren {
  ProtectedOperatorsVerificationUserIdRoute: typeof ProtectedOperatorsVerificationUserIdRoute
  ProtectedOperatorsVerificationIndexRoute: typeof ProtectedOperatorsVerificationIndexRoute
}

const ProtectedOperatorsVerificationRouteChildren: ProtectedOperatorsVerificationRouteChildren =
  {
    ProtectedOperatorsVerificationUserIdRoute:
      ProtectedOperatorsVerificationUserIdRoute,
    ProtectedOperatorsVerificationIndexRoute:
      ProtectedOperatorsVerificationIndexRoute,
  }

const ProtectedOperatorsVerificationRouteWithChildren =
  ProtectedOperatorsVerificationRoute._addFileChildren(
    ProtectedOperatorsVerificationRouteChildren,
  )

interface ProtectedOperatorsRouteChildren {
  ProtectedOperatorsAccountingRoute: typeof ProtectedOperatorsAccountingRoute
  ProtectedOperatorsBlogRoute: typeof ProtectedOperatorsBlogRouteWithChildren
  ProtectedOperatorsContactsRoute: typeof ProtectedOperatorsContactsRoute
  ProtectedOperatorsCouponsRoute: typeof ProtectedOperatorsCouponsRoute
  ProtectedOperatorsDashboardRoute: typeof ProtectedOperatorsDashboardRoute
  ProtectedOperatorsEmailsTestRoute: typeof ProtectedOperatorsEmailsTestRoute
  ProtectedOperatorsReportingRoute: typeof ProtectedOperatorsReportingRoute
  ProtectedOperatorsServiceAreasRoute: typeof ProtectedOperatorsServiceAreasRoute
  ProtectedOperatorsServicesRoute: typeof ProtectedOperatorsServicesRouteWithChildren
  ProtectedOperatorsSettingsRoute: typeof ProtectedOperatorsSettingsRoute
  ProtectedOperatorsUsersRoute: typeof ProtectedOperatorsUsersRouteWithChildren
  ProtectedOperatorsVerificationRoute: typeof ProtectedOperatorsVerificationRouteWithChildren
}

const ProtectedOperatorsRouteChildren: ProtectedOperatorsRouteChildren = {
  ProtectedOperatorsAccountingRoute: ProtectedOperatorsAccountingRoute,
  ProtectedOperatorsBlogRoute: ProtectedOperatorsBlogRouteWithChildren,
  ProtectedOperatorsContactsRoute: ProtectedOperatorsContactsRoute,
  ProtectedOperatorsCouponsRoute: ProtectedOperatorsCouponsRoute,
  ProtectedOperatorsDashboardRoute: ProtectedOperatorsDashboardRoute,
  ProtectedOperatorsEmailsTestRoute: ProtectedOperatorsEmailsTestRoute,
  ProtectedOperatorsReportingRoute: ProtectedOperatorsReportingRoute,
  ProtectedOperatorsServiceAreasRoute: ProtectedOperatorsServiceAreasRoute,
  ProtectedOperatorsServicesRoute: ProtectedOperatorsServicesRouteWithChildren,
  ProtectedOperatorsSettingsRoute: ProtectedOperatorsSettingsRoute,
  ProtectedOperatorsUsersRoute: ProtectedOperatorsUsersRouteWithChildren,
  ProtectedOperatorsVerificationRoute:
    ProtectedOperatorsVerificationRouteWithChildren,
}

const ProtectedOperatorsRouteWithChildren =
  ProtectedOperatorsRoute._addFileChildren(ProtectedOperatorsRouteChildren)

interface ProtectedProviderRouteChildren {
  ProtectedProviderDashboardRoute: typeof ProtectedProviderDashboardRoute
  ProtectedProviderMessagesRoute: typeof ProtectedProviderMessagesRoute
  ProtectedProviderServicesRoute: typeof ProtectedProviderServicesRoute
  ProtectedProviderServiceIdRoute: typeof ProtectedProviderServiceIdRoute
}

const ProtectedProviderRouteChildren: ProtectedProviderRouteChildren = {
  ProtectedProviderDashboardRoute: ProtectedProviderDashboardRoute,
  ProtectedProviderMessagesRoute: ProtectedProviderMessagesRoute,
  ProtectedProviderServicesRoute: ProtectedProviderServicesRoute,
  ProtectedProviderServiceIdRoute: ProtectedProviderServiceIdRoute,
}

const ProtectedProviderRouteWithChildren =
  ProtectedProviderRoute._addFileChildren(ProtectedProviderRouteChildren)

interface ProtectedSubstituteRouteChildren {
  ProtectedSubstituteIdRoute: typeof ProtectedSubstituteIdRoute
  ProtectedSubstituteApplicationsRoute: typeof ProtectedSubstituteApplicationsRoute
  ProtectedSubstituteDashboardRoute: typeof ProtectedSubstituteDashboardRoute
  ProtectedSubstituteMarketplaceRoute: typeof ProtectedSubstituteMarketplaceRoute
  ProtectedSubstituteMessagesRoute: typeof ProtectedSubstituteMessagesRoute
  ProtectedSubstituteServicesRoute: typeof ProtectedSubstituteServicesRoute
}

const ProtectedSubstituteRouteChildren: ProtectedSubstituteRouteChildren = {
  ProtectedSubstituteIdRoute: ProtectedSubstituteIdRoute,
  ProtectedSubstituteApplicationsRoute: ProtectedSubstituteApplicationsRoute,
  ProtectedSubstituteDashboardRoute: ProtectedSubstituteDashboardRoute,
  ProtectedSubstituteMarketplaceRoute: ProtectedSubstituteMarketplaceRoute,
  ProtectedSubstituteMessagesRoute: ProtectedSubstituteMessagesRoute,
  ProtectedSubstituteServicesRoute: ProtectedSubstituteServicesRoute,
}

const ProtectedSubstituteRouteWithChildren =
  ProtectedSubstituteRoute._addFileChildren(ProtectedSubstituteRouteChildren)

interface ProtectedRouteChildren {
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedInvoicesRoute: typeof ProtectedInvoicesRoute
  ProtectedOperatorsRoute: typeof ProtectedOperatorsRouteWithChildren
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedProviderRoute: typeof ProtectedProviderRouteWithChildren
  ProtectedSubstituteRoute: typeof ProtectedSubstituteRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedInvoicesRoute: ProtectedInvoicesRoute,
  ProtectedOperatorsRoute: ProtectedOperatorsRouteWithChildren,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedProviderRoute: ProtectedProviderRouteWithChildren,
  ProtectedSubstituteRoute: ProtectedSubstituteRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface AuthRouteChildren {
  AuthFactorOneRoute: typeof AuthFactorOneRoute
  AuthFactorTwoRoute: typeof AuthFactorTwoRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFactorOneRoute: AuthFactorOneRoute,
  AuthFactorTwoRoute: AuthFactorTwoRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AdminRoute: AdminRoute,
  AuthRoute: AuthRouteWithChildren,
  DemoWorkflowRoute: DemoWorkflowRoute,
  ProviderBillingDutyIdRoute: ProviderBillingDutyIdRoute,
  ProviderPaymentCancelledRoute: ProviderPaymentCancelledRoute,
  ProviderPaymentSuccessRoute: ProviderPaymentSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
